import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {faFacebookF, faTwitter, faInstagram} from "@fortawesome/free-brands-svg-icons"
import "./Footer.css";
function Footer() {
  return (
    <div className="footer">
      <div className="footer-container">
        <p>Restaurante</p>
        <span>
          <a href="tel:5552833055">55 5283 3055</a>
          <span>•</span>
          <a href="tel:5552833056">55 5283 3056</a>
        </span>
        <a className="email" href="mailto:reservaciones@haciendadelosmorales.com">
          reservaciones@haciendadelosmorales.com
        </a>
        <div className="some-container">
          <a href="https://facebook.com/HDeLosMorales" target="_blank" rel="noreferrer">
            <FontAwesomeIcon icon={faFacebookF} />
          </a>
          <a href="https://twitter.com/HDeLosMorales" target="_blank" rel="noreferrer">
            <FontAwesomeIcon icon={faTwitter} />
          </a>
          <a href="https://instagram.com/HDeLosMorales" target="_blank" rel="noreferrer">
            <FontAwesomeIcon icon={faInstagram} />
          </a>
          <span>HDeLosMorales</span>
        </div>
      </div>
      <div className="footer-container">
        <p>BANQUETES</p>
        <span>
          <a href="tel:5552833029">55 5283 3029</a>
          <span>•</span>
          <a href="tel:5552833079">55 5283 3079</a>
        </span>
        <a className="email" href="mailto:reservaciones@haciendadelosmorales.com">
          banquetes@haciendadelosmorales.com
        </a>
        <div className="some-container">
        <a href="https://instagram.com/HDeLosMoralesEventos" target="_blank" rel="noreferrer">
            <FontAwesomeIcon icon={faInstagram} />
          </a>
          <span>HDeLosMoralesEventos</span>
        </div>
      </div>
    </div>
  );
}

export default Footer;
